import { useEffect, useState } from 'react'

export type SiteConfig = {
  coinAddress: string
  twitterUrl: string
  updatedAt: string | null
}

/** The CA and social link are served by our own API rather than baked into the
 *  bundle, so they can be published the moment the token exists without a
 *  rebuild. `null` means "still loading" — distinct from "" which means
 *  "deliberately not set yet". */
export function useSiteConfig(): SiteConfig | null {
  const [config, setConfig] = useState<SiteConfig | null>(null)

  useEffect(() => {
    let alive = true
    const load = () =>
      fetch('/api/config', { cache: 'no-store' })
        .then((r) => (r.ok ? r.json() : Promise.reject(new Error(String(r.status)))))
        .then((c: SiteConfig) => alive && setConfig(c))
        .catch(() => alive && setConfig((prev) => prev ?? { coinAddress: '', twitterUrl: '', updatedAt: null }))

    load()
    // Pick up a live CA update without the visitor reloading.
    const id = setInterval(load, 30_000)
    return () => {
      alive = false
      clearInterval(id)
    }
  }, [])

  return config
}
